import axios from "axios";

export const REGISTER_USER_URL = `${process.env.REACT_APP_API_BASE_TEST}/user`;
export const LOGIN_URL = `${process.env.REACT_APP_API_BASE_TEST}/login`;
export const UPDATE_PASSWORD_URL = `${process.env.REACT_APP_API_BASE_TEST}/password/update`;
export const REQUEST_PASSWORD_URL = `${process.env.REACT_APP_API_BASE_TEST}/password/forgot`;
export const RESET_PASSWORD_URL = `${process.env.REACT_APP_API_BASE_TEST}/password/reset`;

export const ME_URL = "ap/me";

export function login(email, password) {
    return axios.post(LOGIN_URL, {email, password});
}

export function updatePassword(data) {
    return axios.patch(UPDATE_PASSWORD_URL, data);
}

export function registerUser(user) {
    return axios.post(REGISTER_USER_URL, user);
}

export function requestPassword(email) {
    return axios.post(REQUEST_PASSWORD_URL, {email});
}

export function resetPassword(password, password_confirmation, token) {
    return axios.post(RESET_PASSWORD_URL, {password, password_confirmation, token});
}
